import { render, staticRenderFns } from "./EditSensor.vue?vue&type=template&id=edcd675e&scoped=true&"
import script from "./EditSensor.vue?vue&type=script&lang=js&"
export * from "./EditSensor.vue?vue&type=script&lang=js&"
import style0 from "./EditSensor.vue?vue&type=style&index=0&id=edcd675e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edcd675e",
  null
  
)

export default component.exports